import { render } from "./SfxyList.vue?vue&type=template&id=affe61ee"
import script from "./SfxyList.vue?vue&type=script&lang=js"
export * from "./SfxyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__